export const numberParser = {
  strictInteger: (answer: string) => parseInt(answer, 10),
  roundInteger: (answer: string) => Math.round(parseFloat(answer)),
};
